import { CDN_BASE_URL } from '@/settings';

export function getCdnUrl(path: string, ...fallbackPath: string[]): string {
  if (!path && fallbackPath?.length === 0) {
    return;
  }

  if (!path && fallbackPath?.length === 1) {
    return fallbackPath.shift();
  }

  if (!path && fallbackPath.length > 1) {
    return getCdnUrl(fallbackPath.shift(), ...fallbackPath);
  }

  if (path.startsWith('http')) return path;
  return `${CDN_BASE_URL}${path}`;
}

export function getUrlParams(): { [key: string]: any } {
  return window.location.search
    .replace(/^\?/gi, '')
    .split('&')
    .reduce((acc: any, item) => {
      const parts = item.split('=');

      let value: any = decodeURIComponent(parts[1]).trim();

      switch (value) {
        case 'true':
          value = true;
          break;
        case 'false':
          value = false;
          break;
      }

      acc[parts[0]] = value;
      return acc;
    }, {});
}

export function removeURLParameter(urlParameters: string, parameter: string) {
  const params = new URLSearchParams(urlParameters);
  params.delete(parameter);
  return `?${params.toString()}`;
}

export function removeParamUrl(uri: string, remove: string[], addParams?: { [key: string]: any }) {
  const [pathname, search] = uri.split('?');
  const searchParams = new URLSearchParams(search);
  remove.forEach(param => searchParams.delete(param));
  Object.keys(addParams || {}).forEach(key => searchParams.set(key, addParams?.[key]));
  if (searchParams.toString().length === 0) return pathname;
  return `${pathname}?${decodeURIComponent(searchParams.toString())}`;
}

export const parseJwt = <T = any>(token: string): T => {
  if (!token) return;

  const base64Url = token.split('.')[1];
  if (!base64Url) return;
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export const openInNewTab = (url: string | URL | undefined) => {
  if (!url) return;
  window?.open(url, '_blank')?.focus();
};

export const secondsToTimeString = (timeInSeconds: number, displayHours = false): string => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds / 60) % 60).toLocaleString([], { minimumIntegerDigits: 2 });
  const seconds = Math.floor(timeInSeconds % 60).toLocaleString([], { minimumIntegerDigits: 2 });

  if (displayHours || hours > 0) {
    return `${hours}:${minutes}:${seconds}`;
  }

  return `${minutes}:${seconds}`;
};

export const truncateText = (text: string, maxLength = 20) => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};

declare let hj: (...data: any) => void;

export const hjTagging = (...data: any) => {
  if (typeof hj !== 'undefined') {
    hj(...data);
  }
};
